import { ComponentType, createElement } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../hooks';
import { ROUTES } from '../constants/routes';

export const authorized =
  () =>
  <T>(Component: ComponentType<T>) => {
    const EnhancedComponent: ComponentType<T> = (props) => {
      const { isAuthorized } = useAuth();

      if (!isAuthorized) {
        return createElement(Redirect, { to: ROUTES.HOME });
      }

      return createElement(Component, props);
    };

    return EnhancedComponent;
  };
